import { UseGetAllPageSizeProps } from '_api/queries/types';
import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Challenge } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_MY_LIBRARY_CHALLENGES_KEY = 'get-my-library-challenges';

export const useGetMyLibraryChallenges = ({
  page = 0,
  size = 10,
}: UseGetAllPageSizeProps) => {
  return usePermittedQuery<Challenge[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/challenge/my-library?page=${page}&size=${size}`,
    {},
    [GET_MY_LIBRARY_CHALLENGES_KEY],
    {
      enabled: typeof page === 'number' && page >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
